import React from 'react';

const IconLoader = () => (
  <img alt='logo' src="/logo.png"></img>
);

export default IconLoader;
